// import logo from './logo.svg';
import welcomeBanner from "./assets/images/welcomeBanner.png";
import React from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { FaRocket, FaStar } from "react-icons/fa";
import "./App.css";
const DashboardLanding = React.lazy(() =>
  import("./components/DashboardLanding")
);
const NewDashboard = React.lazy(() => import("./components/NewDashboard"));
const PromotionsPage = React.lazy(() => import("./components/PromotionsPage"));
const ChatPage = React.lazy(() => import("./components/ChatPage"));
const PromotionHealthPage = React.lazy(() =>
  import("./components/PromotionHealthPage")
);
const PitchDeck = React.lazy(() => import("./components/PitchDeck"));
const CategoryLanding = React.lazy(() => import("./components/CategoryLanding"));
const ProductDetail = React.lazy(() => import("./components/ProductDetail"));
const ProductReport = React.lazy(() => import("./ProductReport"));
const Styleguide = React.lazy(() => import("./Styleguide"));

function Home() {
  return (
    <div className="App">
      <header className="launch-screen">
        <div className="launch-backdrop" />
        <img
          src={welcomeBanner}
          alt=""
          aria-hidden="true"
          className="launch-bg-image"
        />
        <div className="launch-overlay" />
        <div className="launch-content">
          <div className="launch-icon-row" aria-hidden="true">
            <span className="launch-icon sparkle-left">
              <FaStar />
            </span>
            <span className="launch-icon rocket">
              <FaRocket />
            </span>
            <span className="launch-icon sparkle-right">
              <FaStar />
            </span>
          </div>
          <p className="launch-kicker">Welcome</p>
          <h1>Izy AI Hackathon 2026</h1>
          <p className="launch-subtitle">
            Unified catalog and promotion intelligence dashboard.
          </p>
          <div className="launch-actions">
            <div className="launch-cta-wrap">
              <span className="cta-orb orb-1" aria-hidden="true" />
              <span className="cta-orb orb-2" aria-hidden="true" />
              <span className="cta-orb orb-3" aria-hidden="true" />
              <Link className="launch-cta" to="/dashboard">
                Launch Dashboard
              </Link>
            </div>
            <a
              className="launch-pitch-link"
              href="/dashboard/pitch"
              rel="noreferrer"
            >
              <span className="launch-pitch-title">Pitch Deck</span>
            </a>
          </div>
          <div className="launch-team">
            <p className="launch-team-title">Developers</p>
            <div className="launch-team-list">
              <span>Savan Koradia</span>
              <span>Rajnikant Patoliya</span>
              <span>Divyesh Parmar</span>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <React.Suspense fallback={<div className="App">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<DashboardLanding />} />
          <Route path="/dashboard/catalog" element={<NewDashboard />} />
          <Route path="/dashboard/promotion" element={<PromotionsPage />} />
          <Route path="/dashboard/chat" element={<ChatPage />} />
          <Route path="/dashboard/promotion/health" element={<PromotionHealthPage />} />
          <Route path="/category/:id" element={<CategoryLanding />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/styleguide" element={<Styleguide />} />
          <Route path="/dashboard/pitch" element={<PitchDeck />} />
          <Route path="/productReport" element={<ProductReport />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default App;
